import { motion } from "framer-motion";
import CMSFormInput from "../formFields/CMSFormInput";
import { Formik } from "formik";
import FormButton from "../common/FormButton";
import { useStep } from "../contexts/SubscriptionContext";
import GeneralButton from "../common/GeneralButton";
import { TiChevronLeft } from "react-icons/ti";
import { signInSchema } from "../utils/validations";
import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../../config/axios";
import { useAuth } from "../contexts/AuthContext";
import { useCart } from "../contexts/CartContext";
import { useToast } from "../contexts/ToastContext";
import ContainerLoading from "../common/loading/ContainerLoading";

const SignInStep = () => {
  const { nextStep, prevStep, activeStep } = useStep();
  const [status, setStatus] = useState("idle"); // "idle" | "loading" | "success" | "error"
  const [error, setError] = useState("");
  const { addToast } = useToast();
  const { fetchCart } = useCart();
  const navigate = useNavigate();
  const { setIsLoggedIn } = useAuth();

  // Refs for scrolling to first error
  const refs = {
    email: useRef(null),
    password: useRef(null),
  };

  // Scroll to first error field
  const scrollToFirstError = (errors) => {
    const firstErrorField = Object.keys(errors)[0];
    if (!firstErrorField || !refs[firstErrorField]?.current) return;

    const el = refs[firstErrorField].current;
    el.scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "nearest",
    });
    setTimeout(() => el.focus?.({ preventScroll: true }), 500);
  };

  // Separate submit function
  const handleSignIn = async (values) => {
    setStatus("loading");
    try {
      const response = await axios.post("/auth/signin", {
        email: values.email,
        password: values.password,
      });
localStorage.removeItem("promoCodeSaved") 
      localStorage.setItem("loggedInUser", JSON.stringify(response.data?.user));

      setIsLoggedIn(true);
      setStatus("success");
      await fetchCart();
      navigate("/subscribe/child");
    } catch (err) {
      console.error(err);
      const message =
        err.response?.data?.message || "Sign in failed, please try again";
      setError(message);
       setTimeout(() => {
        setError("");
      }, 5000);
      setStatus("idle");
    }
  };
  return (
    <div>
      <motion.div
        initial={{ x: -200, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        exit={{ x: -200, opacity: 0 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
      >
        <p className="text-34pt pb-4 lg:pb-9">Login or Signup</p>
        <div className="grid grid-cols-1 lg:grid-cols-[3fr_5fr] 2.5xl:grid-cols-[2.504fr_5fr] gap-8 items-start">
          <div>
            <div className="bg-[#DEE2DD] rounded-[15px] py-12 relative flex items-center justify-center relative">
              {status === "loading" && (
                <div className="absolute inset-0 bg-white/70 flex items-center justify-center z-20 rounded-lg">
                  <ContainerLoading />
                </div>
              )}
              {/* <div className="hidden md:flex bg-green w-[41.8px] h-[41.8px] rounded-full flex items-center justify-center absolute -right-5 top-24">
                <p className="text-21pt text-white"> Or</p>
              </div> */}
              <div className="2.5xl:max-w-[354px] w-full px-5 md:px-12 2.5xl:px-0">
                <Formik
                  initialValues={{
                    email: "",
                    password: "",
                  }}
                  validationSchema={signInSchema}
                  onSubmit={(values, { resetForm }) => {
                    handleSignIn(values);
                    nextStep();
                  }}
                >
                  {(form) => (
                    <div className="w-full">
                      {/* Form grid */}
                      <div className="grid grid-cols-1  gap-8">
                        {/* First Name */}
                        <CMSFormInput
                          name="email"
                          label="Email"
                          ref={refs.email}
                          form={form}
                          required
                        />

                        {/* Last Name */}
                        <CMSFormInput
                          name="password"
                          label="Password"
                          ref={refs.password}
                          type="password"
                          form={form}
                          required
                        />
                         {error && (
                        <div
                          className={`relative transition-all duration-300 ease-in-out my-3 ${
                            error
                              ? "opacity-100 -translate-y-3"
                              : "opacity-0 -translate-y-2"
                          }`}
                        >
                          {error && (
                            <span className="errorMessage">{error}</span>
                          )}
                        </div>
                      )}
                        <FormButton
                          text={"Login"}
                          onClick={() => {
                            form.handleSubmit();
                            setTimeout(
                              () => scrollToFirstError(form?.errors),
                              100
                            );
                          }}
                        />
                        <div className="flex flex-col ">
                          <a
                            className="text-18pt text-green hover:text-secondary font-mono leading-none mb-4 cursor-pointer"
                            title="Click to reset password"
                            onClick={() => navigate("/forgot-password")}
                          >
                            Forgot password?
                          </a>
                          <a
                            className="text-18pt text-green hoveFr:text-secondary font-mono cursor-pointer"
                            title="Click to create an account"
                            onClick={() => navigate("/signup?from=plan")}
                          >
                            Signup
                          </a>
                        </div>
                      </div>
                    </div>
                  )}
                </Formik>
              </div>
            </div>
            <GeneralButton
              onClick={() => {
                prevStep();
                navigate(-1);
              }}
              text={"Prev step"}
              iconPosition="Left"
              bgColor="#ccc"
              textColor="#000"
              icon={<TiChevronLeft size={24} className="me-4" />}
              className="text-24pt mt-10"
            />
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default SignInStep;
